import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import { Icon } from "@syarahtech/ui";
var MobileHeader = function MobileHeader(_ref) {
  var title = _ref.title,
    hideBack = _ref.hideBack,
    hideCancel = _ref.hideCancel,
    onClose = _ref.onClose,
    onBack = _ref.onBack;
  var _useTranslation = useTranslation(["web_checkout_finance"]),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "w-full flex items-center justify-between h-16 px-4"
  }, /*#__PURE__*/React.createElement("span", {
    className: "h-6 w-6"
  }, !hideBack && /*#__PURE__*/React.createElement("span", {
    onClick: onBack
  }, /*#__PURE__*/React.createElement("img", {
    className: "en:transform en:[transform:rotateY(180deg)]",
    width: 24,
    height: 24,
    src: CDN_LINK + "/assets/images/mobileBackBlueArr.svg"
  }))), /*#__PURE__*/React.createElement("strong", {
    className: "text-[#484848] font-bold leading-6"
  }, title || ""), /*#__PURE__*/React.createElement("span", {
    className: "h-6 w-10"
  }, !hideCancel && /*#__PURE__*/React.createElement("button", {
    className: "text-[#3C56D4] text-xs font-bold leading-4  border-none bg-transparent",
    onClick: function onClick() {
      return onClose(true);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "text-[#484848]",
    icon: "material-symbols--close",
    width: 5,
    height: 5
  })))));
};
export default MobileHeader;